import { AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { TbSquareRoundedPlusFilled } from 'react-icons/tb';
import AcademiaButton from '../../CommonComps/Buttons/AcademiaButton';
import CreateEditRoleModal from '../../CommonComps/Modals/CreateEditRoleModal';

const CreateRoleAction = ({
  hasCreatePermission,
}: {
  hasCreatePermission: boolean;
}) => {
  // integration of react hooks here
  const [showModal, setShowModal] = useState<boolean>(false);

  // rendering create role action component here
  return (
    <div>
      <AcademiaButton
        title={
          !hasCreatePermission ? 'You do not have permissions!' : undefined
        }
        type='button'
        onClick={() => setShowModal(true)}
        variant='info'
        icon={<TbSquareRoundedPlusFilled className='size-6' />}
        isDisabled={!hasCreatePermission}
      >
        Create Role
      </AcademiaButton>

      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showModal && (
          <CreateEditRoleModal
            title='create'
            handleModalClose={() => setShowModal(false)}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default CreateRoleAction;
